/* eslint-disable react/prop-types */
import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { Table } from '@devexpress/dx-react-grid-material-ui';

const MIN_TABLE_HEIGHT = 180;
const SPACE_FOR_PAGING_AND_VIEWPORT_GUTTER = 72;

const assignRef = (ref, value) => {
  if (typeof ref === 'function') ref(value);
  else if (ref) ref.current = value;
};

export const StickyTableHead = (props) => <Table.TableHead {...props} isFixed />;

const ResponsiveTableContainer = ({ children, forwardedRef, style, ...props }) => {
  const containerRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(MIN_TABLE_HEIGHT);

  const setContainerRef = useCallback(
    (node) => {
      containerRef.current = node;
      assignRef(forwardedRef, node);
    },
    [forwardedRef]
  );

  const updateMaxHeight = useCallback(() => {
    if (!containerRef.current) return;
    const top = containerRef.current.getBoundingClientRect().top;
    // eslint-disable-next-line no-undef
    const availableHeight = window.innerHeight - top - SPACE_FOR_PAGING_AND_VIEWPORT_GUTTER;
    setMaxHeight((current) => {
      const next = Math.max(MIN_TABLE_HEIGHT, Math.floor(availableHeight));
      return current === next ? current : next;
    });
  }, []);

  useLayoutEffect(() => {
    updateMaxHeight();
    // eslint-disable-next-line no-undef
    window.addEventListener('resize', updateMaxHeight);
    // eslint-disable-next-line no-undef
    return () => window.removeEventListener('resize', updateMaxHeight);
  });

  return (
    <div
      {...props}
      ref={setContainerRef}
      style={{
        ...style,
        flexGrow: 1,
        maxHeight,
        overscrollBehavior: 'contain',
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        width: '100%'
      }}
    >
      <div>{children}</div>
    </div>
  );
};

export default ResponsiveTableContainer;
